import axios from "axios";
import baseURL from "../configs/api";

export const getTheAvailableCarsOFBranch = (pickupDate: string, returnDate: string, branchId: number, tenantId: string) => {
    return getFetch(`availableCars`,
        tenantId,
        {
            pickupDate,
            returnDate,
            branchId
        });
}

export const getCarsWithReservation = (reservationId: number, pickupDate: string, returnDate: string, branchId: number, tenantId: string) => {
    return getFetch(`availableCars/GetCarsWithReservation`,
        tenantId,
        {
            reservationId: reservationId,
            pickupDate,
            returnDate,
            branchId
        });
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}